<template>
  <footer id="main-footer" class="f-mainFooter dark-color pt-small">
    <b-row class="pt-small" no-gutters>
      <b-col :class="[{'col-3':!isSmallWindow}, {'col-12':isSmallWindow}]">
        <div class="footer-widget">
          <h3 class="text-light">#AlpFoodway</h3>
          <h5 class="large text-left">{{activeLanguage.alpFoodWayDescription}}</h5>
        </div>
      </b-col>

      <b-col :class="[{'col-9':!isSmallWindow}, {'col-12':isSmallWindow}, 'footer-widget']">
        <b-row class="supporters-box float-right" no-gutters>
          <b-col :class="[{'col-4':!isSmallWindow}, {'col-12':isSmallWindow}]">
            <b-row no-gutters>
              <b-col style="display: flex;">
                <img src="../../assets/partners/europe-logo.jpg"
                     :class="[{'europeLeft': !$store.getters.isMobileValue},'imgLogoEurope']" alt="European Union"
                     v-b-tooltip.hover
                     title="European Union"/>
                <img src="../../assets/partners/european-year.jpg" class="imgLogoEurope"
                     alt="European Year of Cultural Heritage" v-b-tooltip.hover
                     title="European Year of Cultural Heritage"/>
                <img src="../../assets/partners/NRP.jpg" class="imgLogoEurope" alt="NRP" v-b-tooltip.hover
                     title="NRP"/>
              </b-col>
            </b-row>

          </b-col>

          <b-col :class="[{'col-8':!isSmallWindow}, {'col-12':isSmallWindow}]">
            <b-row no-gutters class="spacer">
              <b-col cols="2" style="margin-left: 5px;">
                <a :href="partnersLink + 'polo-poschiavo'" target="_blank">
                  <img class="imgLogoBig" :src="imagePath('polo-poschiavo.jpg')" v-b-tooltip.hover
                       title="Polo Poschiavo"/>
                </a>
              </b-col>
              <b-col cols="2" v-b-tooltip.hover title="Research Centre of the Slovenian Academy of Sciences and Arts"
                     :class="[{slovenianLeft: !$store.getters.isMobileValue}]">
                <a :href="partnersLink + 'zrc-sazu'">
                  <img class="imgLogoBig" :src="imagePath('zrc-sazu.jpg')" target="_blank"/>
                </a>
              </b-col>
              <b-col cols="6" :class="[{colLeft: !$store.getters.isMobileValue}]">
                <b-row no-gutters class="spacer">
                  <b-col v-if="index < 6" v-for="(item, index) in partnersLogoSmall" class="spacer-side" :key="item">
                    <a :href="partnersLink + item.split('.')[0]" target="_blank"
                       :alt="getTooltipName(item.split('.')[0])" v-b-tooltip.hover
                       :title="getTooltipName(item.split('.')[0])">
                      <img :src="imagePath(item)"
                           :class="[{'logo-remove-height' : $store.getters.isMobileValue},'imgLogoSmall']"/>
                    </a>
                  </b-col>
                </b-row>

                <b-row no-gutters>
                  <b-col v-if="index < 12 && index >= 6" v-for="(item, index) in partnersLogoSmall"
                         :key="item" class="spacer-side">
                    <a :href="partnersLink + item.split('.')[0]" target="_blank"
                       :alt="getTooltipName(item.split('.')[0])" v-b-tooltip.hover
                       :title="getTooltipName(item.split('.')[0])">
                      <img :src="imagePath(item)"
                           :class="[{'logo-remove-height' : $store.getters.isMobileValue},'imgLogoSmall']"/>
                    </a>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>

        </b-row>
      </b-col>

    </b-row>

    <div id="footer-rights">
      <div class="container">
        <b-row>
          <b-col cols="12" class="uppercase">
            <h6>Copyright © 2019 / Powered by</h6>
          </b-col>
          <b-col cols="12">
            <a @click="openCreditsModal">
              <img src="../../assets/match_logo.png" class="logo-match" alt="Match Strategies"/>
            </a>
          </b-col>
        </b-row>
      </div>
    </div>
    <credits-modal ref="creditsModal" id="creditsModal"></credits-modal>
  </footer>
</template>

<script>
  import CreditsModal from '../utilComponents/CreditsModal'

  export default {
    name: 'mainFooter',
    components: {CreditsModal},
    data () {
      return {
        partnersLogoSmall: ['lombardy-region.jpg', 'brel.jpg', 'camonica-valley.jpg', 'tsm.jpg', 'dislivelli-association.jpg', 'crepa.jpg', 'kedge-business-school.jpg', 'bauges-park.jpg', 'ragor.jpg', 'rda.jpg', 'munich-university-of-applied-sciences.jpg', 'uibk.jpg'],
        partnersLink: 'http://www.alpine-space.eu/projects/alpfoodway/en/about/partners/',
        isSmallWindow: false
      }
    },
    computed: {
      activeLanguage () {
        return this.$translations[this.$store.getters.currentLanguageValue]
      }
    },
    methods: {
      imagePath (imageName) {
        return require('../../assets/partners/' + imageName)
      },
      getTooltipName (name) {
        switch (name) {
          case 'lombardy-region':
            return 'Ethnographic and Social History Archive – D.G. Culture, Lombardy Region'
          case 'brel':
            return 'Autonomous Region of Aosta Valley - Department for Education and Culture'
          case 'camonica-valley':
            return 'Mountain Community of Camonica Valley'
          case 'tsm':
            return 'Trentino School of Management'
          case 'dislivelli-association':
            return 'Dislivelli Association'
          case 'crepa':
            return 'Regional Center of Alpine Population Studies'
          case 'kedge-business-school':
            return 'Kedge Business School'
          case 'bauges-park':
            return 'Bauges Regional Natural Park'
          case 'ragor':
            return 'Development Agency for Upper Gorenjska'
          case 'rda':
            return 'Regional Development Agency of Northern Primorska Ltd. Nova Gorica'
          case 'munich-university-of-applied-sciences':
            return 'Munich University of Applied Sciences'
          case 'uibk':
            return 'University of Innsbruck'
          default:
            return ''
        }
      },
      openCreditsModal () {
        this.$refs.creditsModal.showModal()
      },
      checkWindowSize () {
        if ((!this.isSmallWindow) && window.innerWidth < 1051) {
          this.isSmallWindow = true
        } else if (this.isSmallWindow && window.innerWidth > 1051) {
          this.isSmallWindow = false
        }
      }
    },
    created () {
      let self = this
      this.checkWindowSize()
      window.addEventListener('resize', function () {
        self.checkWindowSize()
      })
    }
  }

</script>

<style scoped>

  #main-footer {
    text-align: center;
    left: 0;
    bottom: 0;
    width: 100%;
    overflow: hidden;
    background-color: rgb(251, 251, 251) !important;
    color: #999 !important;
    padding-top: 1%;
    border-top: 1px solid #dee2e6 !important;
  }

  #main-footer > div {
    padding-right: 15px;
    padding-left: 15px;
  }

  .footer-widget {

  }

  .footer-widget > h3 {
    color: #555 !important;
    width: 100%;
    text-align: left;
    display: inline-grid;
    font-size: 20px;
  }

  .footer-widget > h5 {
    font-size: medium;
    float: left;
  }

  .footer-widget > ul {
    text-align: left;
  }

  .footer-widget > ul > li {
    margin-bottom: 0.5em;
    padding-bottom: 0.5em;
    border-bottom: 1px solid #B6B6B6;
  }

  .footer-widget > ul > li > h4 > a, #footer-rights > div > div > div > h6 > a {
    color: #c41c21;
    font-size: 14.4px;
  }

  #footer-rights {
    border-top: 0.5px solid #dee2e6 !important;
    padding-bottom: 10px;
    padding-top: 5px;
    background-color: #f5f5f5 !important;
    color: #888 !important;
  }

  .logo-match {
    margin-left: 1%;
    width: 90px;
    cursor: pointer;
  }

  .logo-remove-height {
    height: 60% !important;
  }

  .imgLogoSmall {
    width: 100%;
    height: 80%;
    padding: 1%;
    margin: 1%;
    background-color: white;
  }

  .imgLogoSmall:hover {
    transition-duration: 300ms;
    -webkit-filter: drop-shadow(5px 5px 2px rgba(128, 128, 128, 0.9));
    filter: drop-shadow(5px 5px 2px rgba(128, 128, 128, 0.9));
  }

  .imgLogoEurope:hover {
    transition-duration: 300ms;
    -webkit-filter: drop-shadow(5px 5px 2px rgba(128, 128, 128, 0.9));
    filter: drop-shadow(5px 5px 2px rgba(128, 128, 128, 0.9));
  }

  .imgLogoBig:hover {
    transition-duration: 300ms;
    -webkit-filter: drop-shadow(5px 5px 2px rgba(128, 128, 128, 0.9));
    filter: drop-shadow(5px 5px 2px rgba(128, 128, 128, 0.9));
  }

  .imgLogoBig {
    margin: 0 auto;
    width: 30%;
    padding: 1%;
    /*border: 1px solid #B6B6B6;*/
    background-color: white;
  }

  .imgLogoEurope {
    width: 28%;
    height: 90%;
    padding: 1%;
    /*margin: 1%;*/
    /*border: 1px solid #B6B6B6;*/
  }

  .supporters-box {
    /*padding-bottom: 1%;*/
  }

  .partners {
    height: 100%;
  }

  a {
    width: 24%;
    margin: 1px;
  }

  .spacer {
    padding-bottom: 5% !important;
  }

  .spacer-side {
    padding-right: 2% !important;
  }

  .imgLogo {
    width: 100%;
  }

  .hide-text {
    display: none;
  }

  .europeLeft {
    margin-left: 25%;
  }

  .slovenianLeft {
    margin-left: -50px
  }

  .colLeft {
    margin-left: -25px
  }

</style>



// WEBPACK FOOTER //
// src/components/footerComponents/MainFooter.vue